import styles from './AMSNoAccess.module.scss'

export const AMSNoAccess = () => {
  return <div className={styles.root}>You have no access</div>
}
